/**
 * FSD Configs
 *
 * Created by Shan - 2018-11-14
 */

import { TeamNoteConfig } from '../../configs/models/config';

export const FsdConfig: TeamNoteConfig = {
  HOST: {
    DOMAIN: 'fsd'
  },
  GENERAL: {
    IS_ENABLE_TNC: true,
    PAGE_TITLE: 'Messenger',
    IS_ENABLE_DEBUG: false,
  },
  IMAGES: {
    NOTIFICATION_ICON: 'assets/images/clients/fsd/notification_icon.png',
    FAVICON: 'assets/images/clients/fsd/favicon.png',
    FAVICON_ALERT: 'assets/images/clients/fsd/favicon_alert.png'
  },
  MAP: {

  },
  WEBCLIENT: {
    GENERAL: {
      IS_USE_WEBSOCKET: false,
      IS_ENABLE_CHAT_LIST_MESSAGE_SEARCH: true,
    },
    CHATROOM: {
      IS_ENABLE_SEARCH : true,
      IS_ENABLE_MARKDOWN_INPUT: false,
      ENABLE_ENCRYPTED_MESSAGE: true,
      IS_ENABLE_MESSAGE_ACK: true,
      IS_SHOW_ACK_INFO: true,
      IS_ENABLE_CRITICAL_MSG: true
    },
    NEWS: {
      IS_ENABLE_CONTENT_PREVIEW: true
    }
  }
};
